import { render } from "./RepresentativeCard.vue?vue&type=template&id=a8ea63d6"
import script from "./RepresentativeCard.vue?vue&type=script&lang=js"
export * from "./RepresentativeCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__